import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { AuthenticatedResponse } from './responses/auth.response';

export class AuthService extends BaseService {
    protected get resourceName(): string {
        return 'auth';
    }

    public async login(
        email: string,
        password: string
    ): Promise<AxiosResponse<{ data: AuthenticatedResponse }>> {
        return await this.post({ email, password }, 'login');
    }
}
